import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DiscardConfirmationService {
  visible = signal<boolean>(false);
  title = signal<string>('');
  body = signal<string>('');

  private _decisionSubject = new Subject<boolean>();
  private _decision$ = this._decisionSubject.asObservable();

  show(title: string, body: string): Observable<boolean> {
    this.title.set(title);
    this.body.set(body);
    this.visible.set(true);
    return this._decision$.pipe(take(1));
  }

  confirm(): void {
    this.visible.set(false);
    this._decisionSubject.next(true);
  }

  cancel(): void {
    this.visible.set(false);
    this._decisionSubject.next(false);
  }
}
